(function ($) {
  var apptBook = Drupal.appointmentBooking;

  function getURLParam(oTarget, sVar) {
    return decodeURI(oTarget.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }

  function cancelAppointment(token, id, callback, errorCallback) {
    var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id,
      params = {
        token: token,
        _method: 'DELETE'
      };

    $.ajax(
      {
        url: url,
        type: 'POST',
        data: params,
        success: function (r) {
          if (typeof callback === 'function') {
            callback(r);
          }
        },

        error: function (err) {
          var r = JSON.parse(err.responseText);

          if (typeof errorCallback === 'function') {
            errorCallback(r);
          }
        }
      }
    );
  }
  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var loc = window.parent.location !== window.location ? window.parent.location : window.location,
        apptToken = getURLParam(loc, 'token'),
        apptId = getURLParam(loc, 'appointment_id'),
        confirmClass = 'require-confirm',
        $container = $('#appointment-cancellation'),
        $cMessage = $container.find('.cancel-content'),
        $eMessage = $container.find('.error-content'),
        $cButton = $container.find('.js-appt-confirm');

      function onCancelSuccess(r) {
        $cMessage.show();
        $eMessage.hide();
      }

      function onConfirmCancelSuccess(r) {
        onCancelSuccess();
        $container.removeClass(confirmClass);
      }

      function onCancelError(r) {
        $eMessage.show();
        $cMessage.hide();
      }

      function onConfirmCancelError(r) {
        onCancelError();
        $container.removeClass(confirmClass);
      }

      if ($container.data('customer-confirmation')) {
        $cButton.on('click', function (e) {
          e.preventDefault();
          cancelAppointment(apptToken, apptId, onConfirmCancelSuccess, onConfirmCancelError);
        });
      } else {
        if (apptToken && apptId) {
          cancelAppointment(apptToken, apptId, onCancelSuccess, onCancelError);
        }
      }
    }
  };
})(jQuery);
